<template>
    <div>
        <el-form style="margin-top: 10px;" :model="p2Item" :rules="p2FormRules" ref="p2FormRef" label-width="150px">
            <el-row>
                <el-col :span="22">
                    <el-badge :value="projectStruct" class="item width-100">
                        <el-form-item label="数据表头：" prop="projectStruct">
                            <el-input type="textarea" v-model="p2Item.projectStruct"></el-input>
                        </el-form-item>
                    </el-badge>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="22">
                    <el-badge :value="projectStructCn" class="item width-100">
                        <el-form-item label="中文表头：" prop="projectStructCn">
                            <el-input type="textarea" v-model="p2Item.projectStructCn"></el-input>
                        </el-form-item>
                    </el-badge>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="22">
                    <el-form-item label="系统图：" prop="flashAddress">
                        <el-input v-model="p2Item.flashAddress"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="11">
                    <el-form-item label="控制：" prop="hasControl">
                        <el-select v-model="p2Item.hasControl" placeholder="请选择">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="参数：" prop="hasSetParameter">
                        <el-select v-model="p2Item.hasSetParameter" placeholder="请选择">
                            <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="11">
                    <el-form-item label="系统标识：" prop="systemTag">
                        <el-input v-model="p2Item.systemTag"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="模版类型：" prop="moduleName">
                        <el-input v-model="p2Item.moduleName"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="11">
                    <el-form-item label="系统类型：" prop="sysId">
                        <el-input v-model="p2Item.sysId"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="说明书的URL：" prop="instructionsUrl">
                        <el-input v-model="p2Item.instructionsUrl"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="22">
                    <el-form-item label="备注：" prop="remark">
                        <el-input type="textarea" v-model="p2Item.remark"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>

export default {
    name: '',
    props: {
        item: {
            type: Object,
            default: function () {
                return {
                    projectStruct: '',
                    projectStructCn: '',
                    flashAddress: '',
                    hasControl: 0,
                    hasSetParameter: 0,
                    systemTag: 'CIB',
                    moduleName: '',
                    sysId: '4',
                    instructionsUrl: '',
                    remark: ''
                }
            }
        }
    },
    data() {
        return {
            options: [
                {value: true,label:'是'},
                {value: false,label:'否'}
            ]
        }
    },
    methods:{
        async validateForm() {
            let p =await  new Promise((resolve, reject)=>{
                this.$refs.p2FormRef.validate(async (valid)=>{
                    valid ? resolve() : reject()
                })
            })
            return p
        },
        reset(){
            this.$nextTick(() => {

            })
            this.$refs.p2FormRef.resetFields()
        },
        checkProjectStruct(rule, value,callback){
            // this.p2Item.projectStruct=checkStruct(value)
            // 后续加校验
            return callback()
        },
        check(){
            if(this.projectStruct != this.projectStructCn){
                this.$message.error('中英文字段数量不匹配！')
                return false
            }
            return true
        }
    },
    computed: {
        p2FormRules: function () {
            let arr = {}
            arr.projectStruct = [
                {required: true, message: '请输入表头', trigger: 'blur'},
                {validator: this.checkProjectStruct, trigger: 'blur'}
            ]
            return arr
        },
        projectStruct: function (){
            if(this.p2Item.projectStruct.trim()==='') return 0
            return this.p2Item.projectStruct.split(',').length
        },
        projectStructCn: function (){
            if(this.p2Item.projectStructCn.trim()==='') return 0
            return this.p2Item.projectStructCn.split(',').length
        },
        p2Item: function (){
            return this.item
        }
    },
    created() {

    }
}
</script>

<style scoped>
.width-100 {
    width: 100%;
}
</style>
